import styled from 'styled-components';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-width: 500px;
    max-width: 100%;
    @media (max-width: 550px) {
        min-width: 100%;
    }
    .otp-input {
        border-radius: 10px;
        border: 0;
        background-color: #f1f3f5;
        margin: 1px;
        justify-content: space-between;
        height: 52px;
        width: 72px !important;
    }

    @media (max-width: 550px) {
        .otp-input {
            height: 40px;
            width: 40px !important;
        }
    }

    .otp-container {
        justify-content: space-between;
    }
`;
export const StyledTitle = styled.h2(
    (p) => `
    font-size: ${p.theme.fontSizes.title};
    color: ${p.theme.colors.black};
    margin: 0;
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`
);
export const StyledHeading = styled.p(
    (p) => `
    font-size: ${p.theme.fontSizes.heading};
    color: ${p.theme.colors.muted};
    margin: 0px;
    font-weight: 300;
    line-height: 26px;
`
);
export const StyledOtpContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 100%;
    min-height: 75px;
    margin-top: 42px;
    margin-bottom: 27px;
    @media (max-width: 550px) {
        margin: 20px 0px;
        min-height: 0;
    }
`;
export const StyledImage = styled.img`
    margin-left: 5px;
`;
